import type { Currency } from "@store/api/interfaces";

export function useCurrency() {
	const getCurrencySymbol = (code: Currency|null|undefined): string|null => {
		switch (code) {
			case 'rub': return '₽';
			default: return null;
		}
	}

	/**
	 * Валюта витрины для языка интерфейса.
	 *
	 * Правило живёт здесь, а не в трёх компонентах: тарифы, пакеты и чекаут
	 * обязаны выбирать одну и ту же валюту, иначе на странице оплаты окажется
	 * рублёвый пакет рядом с долларовой подпиской.
	 */
	const getDisplayCurrency = (locale: string): Currency => {
		return (locale === 'ru' || locale === 'en') ? 'rub' : 'usd';
	}

	return {
		getCurrencySymbol,
		getDisplayCurrency
	};
}
